import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./../../../public/scss/feedComponent.scss";

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faTimes } from '@fortawesome/free-solid-svg-icons';
// import store from './../store';
// import PropTypes from 'prop-types';
// import { sendLoginCredentials, getParetQuestions, submitFormNow } from './../actions/formActions';
import { connect } from 'react-redux';
// import { getUserData, logOut } from './../actions/utility';

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    Button,
    Container,
    Row,
    Media,
    Col,
    Card,
    CardTitle,
    CardSubtitle,
    CardBody,
    CardText,
    CardLink,
    Badge,
    Spinner
    // NavLink
} from "reactstrap";

import yTubeIcon from "./../../../public/images/youtubeIcon.svg";

class AutoPopulatedFeedComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
        studentInfo : this.props.studentInfo,
        studentProgarms : this.props.studentProgarms,
        topicVideos: this.props.topicVideos,
        programRelatedData: this.props.programRelatedData,
        randomImages: this.props.randomImages,
        topicWorkSheets: this.props.topicWorkSheets,
        showWorksheets : this.props.showWorksheets,
        randomImageState : false,
        showMoreVideos : false,
        isShowWorkSheet : false
    };

  }

  componentWillReceiveProps(nextProps, thisProps) {
    if(nextProps.studentInfo){
        this.setState({
            studentInfo: nextProps.studentInfo
        })
    }
    if(nextProps.studentProgarms){
        this.setState({
        studentProgarms: nextProps.studentProgarms
        })
    }
    if(nextProps.topicVideos){
        this.setState({
            topicVideos: nextProps.topicVideos
        })
    }
    if(nextProps.programRelatedData){
        this.setState({
            programRelatedData: nextProps.programRelatedData
        })
    }
    if(nextProps.randomImages){
        this.setState({
            randomImages: nextProps.randomImages
        })
    }
    if(nextProps.topicWorkSheets){
        this.setState({
            topicWorkSheets: nextProps.topicWorkSheets
        })
    }
    
  }
  showWorksheetsSpec = (index) => {
    var temp_array = this.state.showWorksheets;
    temp_array[index] = !temp_array[index];
    this.setState({
        showWorksheets: temp_array
    })
}
  
  componentDidMount() {
  }

  formatDate(date) {
    var newDate = date.split('-');
    newDate = newDate[2] + "/" + newDate[1] + "/" + newDate[0];

    return newDate;
  }

  createStars = (length, dynamicColor) => {
    let stars = [];

    // Outer loop to create parent
    for (let i = 0; i < length; i++) {
        
        let star = <FontAwesomeIcon className={'star star'+(i+1)} key={i} icon={faStar} size="3x" color={"#fff"} style={{backgroundColor: dynamicColor}} />;

        stars.push(star)
    }
    return stars
  }


  render() {
    console.log(this.props);
    console.log("Topics worksheet" , this.state.topicWorkSheets);
    console.log("posiion" , this.props.position);
    console.log("feed" , this.props.data);

    var feed = this.props.data;
    var key = this.props.key2;
    var programName = this.state.programRelatedData.program_name;
    var chapterName = this.state.programRelatedData.chapter_name;
    var randomImages = this.state.randomImages;
    var position = this.props.position;
    // var topicName = feed.topic_name;
    // var topic_id   = feed.feed_topic_id;
    var topicName = null;
    var topic_id   = null;
    debugger;
    // console.log(feed.testid,":Topics worksheet" , this.state.topicWorkSheets[feed.testid]);
    // try {
    //     this.state.topicWorkSheets[feed.testid].map((worksheetList, index) =>{
    //         console.log("worksheetList:",worksheetList);
    //     })
    // }
    // catch(e) {
    //     console.log(e);
    // }
    var dateTime = null;
    try{
        var timeStamp = feed.ts;
        var splittedTimeStamp = timeStamp.split(" ");
        dateTime = this.formatDate(splittedTimeStamp[0]);
    }
    catch(e) {
        console.log(e);
    }
    
    var studentName = this.state.studentInfo.user_name;
    // var program_id = feed.feed_prog_id;
    
    var program_id = 0;
    // try{
    //     studentName = studentName.split(' ');
    //     studentName = studentName[0];
    // }
    // catch(e){
    //     console.log(e);
    // }

    var randomImage;
    var imgLength;
    var imgIndex;
    var randomImage;
    var starsLength = 0;
    
    try{

        if(position == "right"){
            if(feed.beforeScore <= 20){ // inadequate
                starsLength = 1;
                imgLength = (randomImages.before.inadequate.length - 1);
                imgIndex = randomImages.before.inadequate[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
            else if(feed.beforeScore <= 40){ // marginal
                starsLength = 2;
                imgLength = (randomImages.before.marginal.length - 1);
                imgIndex = randomImages.before.marginal[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
            else if(feed.beforeScore <= 60){ // adequate
                starsLength = 3;
                imgLength = (randomImages.before.adequate.length - 1);
                imgIndex = randomImages.before.adequate[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
            else if(feed.beforeScore <= 80){ // good
                starsLength = 4;
                imgLength = (randomImages.before.good.length - 1);
                imgIndex = randomImages.before.good[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
            else if(feed.beforeScore <= 100){ // excellent
                starsLength = 5;
                imgLength = (randomImages.before.excellent.length - 1);
                imgIndex = randomImages.before.excellent[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
    
        }
        else{
            if(feed.afterScore <= 20){
                starsLength = 1;
                imgLength = (randomImages.after.inadequate.length - 1);
                imgIndex = randomImages.after.inadequate[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
            else if(feed.afterScore <= 40){
                starsLength = 2;
                imgLength = (randomImages.after.marginal.length - 1);
                imgIndex = randomImages.after.marginal[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
            else if(feed.afterScore <= 60){
                starsLength = 3;
                imgLength = (randomImages.after.adequate.length - 1);
                imgIndex = randomImages.after.adequate[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
            else if(feed.afterScore <= 80){
                starsLength = 4;
                imgLength = (randomImages.after.good.length - 1);
                imgIndex = randomImages.after.good[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
            else if(feed.afterScore <= 100){
                starsLength = 5;
                imgLength = (randomImages.after.excellent.length - 1);
                imgIndex = randomImages.after.excellent[Math.round(parseInt(Math.random() * (imgLength - 0) + 0))];
            }
    
        }

        // render random image for before / after post
        if(!this.state.randomImageState) {
            randomImage = imgIndex.image_type + "/" + imgIndex.image_for + "/" + imgIndex.image_grade + "/" + imgIndex.image_name;
        }
        else{
            randomImage = this.state.randomImageState
        }
        console.log(imgIndex);

    }
    catch(e){
        console.log(e);
    }

    

    // var position = this.props.position;

    return (
        <Card id={'currentpost' + key} style={{marginBottom: '2vh', border: '1px #ccc solid', textAlign: 'left'}}>
            
            <CardBody>
                <CardTitle>
                    <h5><strong>{ studentName }</strong> took a test <strong>{ feed.testname }</strong></h5>
                </CardTitle>
                <CardSubtitle>
                    {/* <Row>
                        <Col> */}
                        {
                            programName && programName != null ?
                            <p style={{fontSize: '12px', color: '#000', margin: 0}}>
                                Program: <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: programName}}></span>
                            </p>
                            : null
                        }
                        {
                            chapterName && chapterName != null ?
                            <p style={{fontSize: '12px', color: '#000', margin: 0}}>
                                Chapter: <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: chapterName}}></span>
                            </p>
                            : null
                        }
                        {
                            dateTime ?
                                <p style={{fontSize: '11px', color: '#565656', margin: 0, marginTop: '10px'}}>
                                    on <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: dateTime}}></span>
                                </p>
                            : null
                        }
                        {/* </Col>
                    </Row> */}
                </CardSubtitle>
            </CardBody>

            <CardBody style={{padding : 0}}>
                <Row style={{margin: 0}}>
                    
                    <Col className="autoPopulatedPost"
                        style={{backgroundImage: randomImage && randomImage != undefined ? "url(http://lincolnmethod.s3.us-east-1.amazonaws.com/randomFeedImages/"+ randomImage +")" : null}}>

                        <Row>
                            <Col xs={{size: 6, offset: this.props.position == "left" ? 6 : 0}}>
                                <div className={this.props.position == "left" ? "details left" : "details right"}>
                                    
                                    <div className="ratings">
                                        {
                                            this.createStars(starsLength, this.props.position == "left" ? '#56e60d' : '#ff0300')
                                        }
                                    </div>
                                    
                                    <h3>
                                        {
                                            this.props.position == "right" ? feed.beforeScore : feed.afterScore
                                        }
                                        <span style={{fontSize: '20px'}}>%</span></h3>
                                    <h5 style={{fontSize: '12px'}}>({
                                        this.props.position == "right" ? "1st attempt " : "Improved "
                                    }test score)</h5>
                                    <h5 style={{fontSize: '12px'}}>Topic: {feed.testname}</h5>
                                    <hr/>
                                    {
                                        feed.correctAns ?
                                            this.props.position == "right" ?
                                                <p>Correct answers: {feed.correctAns}</p>
                                            :
                                                <p>Correct answers: {
                                                    // calculating after correct answers
                                                    parseInt((parseInt(feed.afterScore) / 100) * (feed.correctAns + feed.inCorrecttAns))
                                                }</p>
                                        : null
                                    }
                                    {
                                        feed.inCorrecttAns ?
                                            this.props.position == "right" ?
                                                <p>Incorrect answers: {feed.inCorrecttAns}</p>
                                            :
                                                <p>Incorrect answers: {
                                                    // calculating after inCorrect answers
                                                    parseInt((feed.correctAns + feed.inCorrecttAns) - ((parseInt(feed.afterScore) / 100) * (feed.correctAns + feed.inCorrecttAns)))
                                                }</p>
                                        : null
                                    }

                                </div>
                            </Col>
                        </Row>

                    </Col>

                </Row>
            </CardBody>
            

            {
                this.props.position == "right" && this.state.topicVideos && this.state.topicVideos.length ?


                            // return (
                                <CardBody style={{paddingTop: 0}}>
                                    <div className="taggedVideos">
                                        <hr style={{marginTop: 0}} />
                                        <p style={{fontWeight: 'bold'}}>Watch these suggested videos to improve even further</p>
                                        <Row className={!this.state.showMoreVideos ? "taggedVideosRow" : "taggedVideosRow opened"}>
                                        {
                                            
                                            this.state.topicVideos.map((videos, key) => 

                                                videos && videos[feed.testid] && videos[feed.testid].length && videos[feed.testid].map((video, key) => 
                                                {
                                                    // console.log(video);
                                                    // if(!this.state.showMoreVideos && key > 2){
                                                    //     return false;
                                                    // }
                                                    // else{
                                                        return (
                                                            <Col key={key} md={{size: 4}} xs={{size: 12}}>
                                                                <a className="redirectAnchor" href={video.video_url} target="_new">
                                                                    {/* <iframe width="100%" height="100" src={video.video_url.replace("/watch?v=", "/embed/") + "?controls=0?start=" + video.video_start} frameBorder="0"  allowFullScreen></iframe> */}
                                                                    <Media object src={yTubeIcon} alt={yTubeIcon} />
                                                                    <p>
                                                                        {video.video_caption}
                                                                        {/* <span style={{fontSize: '10px', display: 'block'}}>{video.video_url}</span> */}
                                                                    </p>
                                                                </a>
                                                            </Col>
                                                        )
                                                    // }                                                        

                                                })
                                            )
                                        }
                                        </Row>
                                        {
                                            !this.state.showMoreVideos ?
                                                <Row>
                                                    <Col md={{size : 12}}>
                                                        <p style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={e => this.setState({
                                                            showMoreVideos : true,
                                                            randomImageState : randomImage
                                                        }, () => {
                                                            // console.log(this.state.randomImageState)
                                                        })}>Show all suggested videos</p>
                                                    </Col>
                                                </Row>
                                            : null
                                        }
                                        
                                        {/* {
                                            this.state.topicVideos.map((videos, key) => 

                                                videos && videos[feed.testid] && videos[feed.testid].length > 3 && !this.state.showMoreVideos ?
                                                    <Row key={key}>
                                                        <Col md={{size : 12}}>
                                                            <p style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={e => this.setState({
                                                                showMoreVideos : true,
                                                                randomImageState : randomImage
                                                            }, () => {
                                                                // console.log(this.state.randomImageState)
                                                            })}>View all suggested videos</p>
                                                        </Col>
                                                    </Row>
                                                : null
                                            )
                                        } */}
                                        
                                    </div>
                                </CardBody>                                
                            // )
                            
                : null
            }

            {/* For Worksheet */}

            {/* {
                this.props.position == "right" && this.state.topicWorkSheets && typeof this.state.topicWorkSheets === "object" ?


                                <CardBody style={{paddingTop: 0}}>
                                    <h5>Worksheets here</h5>
                                    <div className="taggedVideos">
                                        <hr style={{marginTop: 0}} />
                                        <p style={{fontWeight: 'bold'}}>Watch these suggested videos to improve even further</p>
                                        <Row className={!this.state.showMoreVideos ? "taggedVideosRow" : "taggedVideosRow opened"}>
                                        {
                                            
                                            this.state.topicVideos.map((videos, key) => 

                                                videos && videos[feed.testid] && videos[feed.testid].length && videos[feed.testid].map((video, key) => 
                                                {
                                            
                                                        return (
                                                            <Col key={key} md={{size: 4}} xs={{size: 12}}>
                                                                <a className="redirectAnchor" href={video.video_url} target="_new">
                                                                    <Media object src={yTubeIcon} alt={yTubeIcon} />
                                                                    <p>
                                                                        {video.video_caption}
                                                                    </p>
                                                                </a>
                                                            </Col>
                                                        )
                                                })
                                            )
                                        }
                                        </Row>
                                        {
                                            !this.state.showMoreVideos ?
                                                <Row>
                                                    <Col md={{size : 12}}>
                                                        <p style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={e => this.setState({
                                                            showMoreVideos : true,
                                                            randomImageState : randomImage
                                                        }, () => {
                                                        })}>Show all suggested videos</p>
                                                    </Col>
                                                </Row>
                                            : null
                                        }
                                        
                                    </div>
                                </CardBody>                                                            
                : null
            } */}
            {
                typeof this.state.topicWorkSheets[feed.testid] !=="undefined" && this.state.topicWorkSheets[feed.testid].length > 0 ? 
                   
                
                    <CardBody  style={{textAlign: 'right', background: "#e5f1ff", paddingTop: '10px', paddingBottom: '10px'}}>
                        {
                        this.state.isShowWorkSheet == false ? 
                        <Button color="primary" size="sm" className="worksheetsButton" onClick={()=>{
                            this.setState({isShowWorkSheet : true})
                        }}>
                            {
                                
                                    <span>Show practice worksheets&nbsp; <Badge color="warning">{ this.state.topicWorkSheets[feed.testid].length ? this.state.topicWorkSheets[feed.testid].length : 1 }</Badge></span> 
                            }
                        </Button>
                        :null
                        }
                        {
                        this.state.isShowWorkSheet == true ? 
                            <div style={{textAlign:'left'}} className="taggedWorksheets">
                                {/* <hr /> */}
                                <p style={{fontSize: '14px', color: '#366394'}}>Try these practice worksheets</p>
                                <Row>
                                    <Col>
                                        <ol className="worksheetlist">
                                        {
                                        this.state.topicWorkSheets[feed.testid].map((worksheetList, index) => 
                                            {
                                                return (
                                                    <li>
                                                        <p>
                                                        {
                                                            worksheetList.is_s3 == 1 ? 
                                                                <a href={"https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/" + worksheetList.file_name} target="_new">
                                                                    <span className="indexing">{index+1}</span>
                                                                    {worksheetList.file_label}<br />
                                                                </a>
                                                            :
                                                                typeof worksheetList.file_name !=="undefined" ? 
                                                                    <a href={"https://dashboard.lincolnmethod.com/uploads/worksheets/" + worksheetList.file_name} target="_new">
                                                                        <span className="indexing">{index+1}</span>
                                                                        {worksheetList.file_label}<br />
                                                                    </a>
                                                                : null
                                                        }
                                                        {
                                                            worksheetList.link !=null &&  worksheetList.link_label != null?
                                                                <a href={worksheetList.link} target="_new">
                                                                    <span className="indexing">{index+1}</span>
                                                                    {worksheetList.link_label}<br />
                                                                </a>
                                                        :null 
                                                        }
                                                        </p>
                                                    </li>
                                                )
                                            })
                                        }    
                                       </ol>
                                    </Col>
                                </Row>
                            </div>
                        :null    
                        }
                    </CardBody>
                
                :null
            }
        </Card>
    )
  }
}

AutoPopulatedFeedComponent.propTypes = {
    
}

const mapStateToProps = state => ({
    
})

export default connect(mapStateToProps, {  })(AutoPopulatedFeedComponent);
